import { BoilerAdapter, HeatingCircuit } from 'z3k-config';
import { OpenThermVariableName } from 'openTherm';
import { createSelector } from '@reduxjs/toolkit';
export function getLegacyOpenThermObserveParams(flags, ot_save_params) {
    return ot_save_params
        ? flags.filter((sensor) => ot_save_params.includes(sensor.ot_name))
        : flags;
}
export function getLegacyBoilerName(thermostat_zones_settings, id) {
    const boilers_names = Object.fromEntries(Object.entries(thermostat_zones_settings || {}).filter(([, spec]) => spec.flags.includes('boiler')));
    return boilers_names[id]?.name ?? undefined;
}
const allBoilerLoggedParameters = [
    OpenThermVariableName.bt,
    OpenThermVariableName.dt,
    OpenThermVariableName.rwt,
    OpenThermVariableName.ot,
    OpenThermVariableName.rml,
    OpenThermVariableName.wp,
    OpenThermVariableName.fr,
];
export function notAvailableOTFlags(ot_save_params) {
    return ot_save_params != null
        ? new Set(allBoilerLoggedParameters.filter((parameter) => !ot_save_params.includes(parameter)))
        : new Set();
}
//беру только те АЦШ, которые включены и назначены во включенный контур
export const selectEnabledBoilerAdapters = createSelector((config) => config, (config) => BoilerAdapter.get.where(config, (ba) => 
//https://git.microline.ru/zont/server/-/issues/1291
BoilerAdapter.isEnabled(ba) &&
    HeatingCircuit.get.some(config, (hc) => 
    // https://git.microline.ru/zont/server/-/issues/1269
    HeatingCircuit.isEnabled(hc) &&
        hc.control_devices.includes(ba.id))));
